"use client"
import { forwardRef, type ComponentProps } from "react"
import NextLink from "next/link"
import { LinkProvider, type LinkComponentProps } from "@cloudflare/kumo/utils"
const AppLink = forwardRef<HTMLAnchorElement, LinkComponentProps>(function AppLink(
  { href, to, ...props },
  ref,
) {
  // Kumo's Link passes `href`; Kumo's Breadcrumbs.Link passes `to`.
  return <NextLink ref={ref} href={href ?? to ?? ""} {...props} />
})
export function AppTheme({
  children,
  ...props
}: ComponentProps<"div">) {
  return (
    <LinkProvider component={AppLink}>
      <div {...props} data-mode="light">
        {children}
      </div>
    </LinkProvider>
  )
}
